import React, { useState, useEffect } from "react"; // Import useState and useEffect hooks
import {
  Modal,
  ModalContent,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Tooltip,
  Tabs,
  Tab,
  Button,
  Switch,
} from "@heroui/react";
import ColorFilter from "@/components/Filters/ColorFilter";
import CostFilter from "@/components/Filters/CostFilter";
import PowerFilter from "@/components/Filters/PowerFilter";
import SearchSelect from "@/components/Filters/SearchSelect";
import NameFilter from "@/components/Filters/NameFilter";
import TypeFilter from "@/components/Filters/TypeFilter";
import CounterFilter from "@/components/Filters/CounterFilter";
import AttributeFilter from "@/components/Filters/AttributeFilter";
import FormatFilter, { formats } from "@/components/Filters/FormatFilter";
import ShowAAsFilter from "@/components/Filters/ShowAAsFilter";
import DeckCommonCardsFilter from "@/lib/games/onePiece/DeckCommonCardsFilter";
import { IconAdjustmentsHorizontal } from "@tabler/icons-react";
import PriceDiffFilter from "@/components/Filters/PriceDiffFilter";
import PercentFilter from "@/components/Filters/PercentFilter";

export default function AdvancedFiltersModal({
  filters,
  setFilter,
  clearAllFilters,
  isOpen,
  onClose,
  onReset,
  searchDisplay,
  setSearchDisplay,
  deckCardsMap,
}: {
  filters: any;
  setFilter: any;
  clearAllFilters: any;
  isOpen: any;
  onClose: any;
  onReset: any;
  searchDisplay: any;
  setSearchDisplay: any;
  deckCardsMap: any;
}) {
  return (
    <Modal
      disableAnimation
      size="md"
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior={"outside"}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1 text-center">
              All Filters
            </ModalHeader>
            <ModalBody>
              <div className="flex flex-col flex-wrap gap-4 my-2"></div>
              <div className="flex flex-col gap-2 mt-2 mb-2">
                <div className="flex flex-row">
                  <SearchSelect
                    selected={filters.searchSelect}
                    setSelected={(val: any) => setFilter("searchSelect", val)}
                  />
                  <NameFilter
                    selected={searchDisplay}
                    setSelected={setSearchDisplay}
                    placeholder={"Search"}
                    rounded="rounded-l-none"
                  />
                </div>
                <DeckCommonCardsFilter
                  selected={filters.deckCommonCards}
                  setSelected={(val: any) => setFilter("deckCommonCards", val)}
                  deckCardsMap={deckCardsMap}
                />
                <ColorFilter
                  selected={filters.color}
                  setSelected={(val: any) => setFilter("color", val)}
                />
                <CostFilter
                  selected={filters.cost}
                  setSelected={(val: any) => setFilter("cost", val)}
                />
                <PowerFilter
                  selected={filters.power}
                  setSelected={(val: any) => setFilter("power", val)}
                />
                <TypeFilter
                  selected={filters.type}
                  setSelected={(val: any) => setFilter("type", val)}
                />
                <CounterFilter
                  selected={filters.counter}
                  setSelected={(val: any) => setFilter("counter", val)}
                />
                <AttributeFilter
                  selected={filters.attribute}
                  setSelected={(val: any) => setFilter("attribute", val)}
                />
                <FormatFilter
                  customData={formats}
                  selected={filters.format}
                  setSelected={(val: any) => setFilter("format", val)}
                />
                <ShowAAsFilter
                  selected={filters.showAAs}
                  setSelected={(val: any) => setFilter("showAAs", val)}
                />
                {/* <Button
                  // color="primary"
                  // variant=""
                  onPress={() => {
                    clearAllFilters();
                  }}
                  radius="sm"
                  className="h-[30px]"
                  // endContent={<IconX height={14} width={14} />}
                >
                  Clear
                </Button> */}
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                variant="light"
                color="danger"
                onPress={() => {
                  // do this to rerender the components because they get stuck on previous value
                  //   setPriceFilterKey((prev: number) => prev + 1);
                  //   setPercentFilterKey((prev: number) => prev + 1);
                  onReset();
                }}
                className="mr-auto"
              >
                Clear All
              </Button>
              <Button color="primary" onPress={onClose}>
                Close
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}
